import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILED,
  REMOVE,
  REMOVE_SUCCESS,
  REMOVE_FAILED,
} from './constants';

export const initAction = (id, budgetId) => ({
  type: INIT,
  id,
  budgetId,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error, errorCode) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const saveAction = (data) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = (form) => ({
  type: SAVE_SUCCESS,
  form,
});
export const saveFailedAction = (error, errorCode, additional) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const removeAction = (donationMatchingRuleId) => ({
  type: REMOVE,
  donationMatchingRuleId,
});
export const removeSuccessAction = () => ({
  type: REMOVE_SUCCESS,
});
export const removeFailedAction = (error, errorCode, additional) => ({
  type: REMOVE_FAILED,
  error,
  errorCode,
  ...additional,
});
